module.exports = __webpack_public_path__ + "static/media/dennis.ae7a51b9.png";